export type Listener = (identifier: string, group: string) => void;

export type Payload = Record<string, string>;

export type Data = {
  type: Types;
  payload: string;
  group: string;
};

export enum Types {
  EXPERIMENT_ALL = 'EXPERIMENT_ALL',
  EXPERIMENT_ALL_INIT = 'EXPERIMENT_ALL_INIT',
  EXPERIMENT_UPDATE = 'EXPERIMENT_UPDATE',
  EXPERIMENT_BROADCAST_REQUEST = 'EXPERIMENT_BROADCAST_REQUEST',
  EXPERIMENT_UPDATE_ALLOCATION = 'EXPERIMENT_UPDATE_ALLOCATION',
  EXPERIMENT_REMOVE_EXPERIMENT = 'EXPERIMENT_REMOVE_EXPERIMENT',
}

export type Allocation = {
  experimentIdentifier: string;
  group: VariationType;
};

export enum EventActions {
  SEEN = 'seen', // TODO remove when there are no <Experiment> components with the `legacy` key anymore
  MISSING_VARIATION = 'missing_variation', // TODO remove when there are no <Experiment> components with the `legacy` key anymore
  INVALID_EXPERIMENT_GROUP = 'invalid_experiment_group', // TODO remove when there are no <Experiment> components with the `legacy` key anymore
  EXCLUDE = 'exclude', // TODO remove when there are no <Experiment> components with the `legacy` key anymore
  ALLOCATION = 'allocation',
  ERROR = 'error',
}

export enum EventLabels {
  // @ deprecated use ABEXPERIMENT instead
  ABTEST = 'ab_test', // TODO remove when there are no <Experiment> components with the `legacy` key anymore
  SUCCESS = 'success',
  MISSING_VARIATION = 'missing_variation',
  INVALID_EXPERIMENT_GROUP = 'invalid_experiment_group',
}

export type ExperimentTrackingEvent = {
  action: EventActions | string;
  label: EventLabels | string;
  payload: Partial<
    {
      auto: boolean;
      // @deprecated use experimentId instead
      testId: string; // TODO remove when there are no <Experiment> components with the `legacy` key anymore
      experimentId: string;
      // @deprecated use experimentGroup instead
      testGroup: VariationType; // TODO remove when there are no <Experiment> components with the `legacy` key anymore
      experimentGroup: VariationType;
      isMobileDevice: boolean;
      isMobileLayout: boolean;
    } & Record<any, any>
  >;
};

export type ReceivedVariations = Array<{
  group: Exclude<VariationType, 'excluded'>;
  node: React.ReactNode;
}>;

export type valueof<T> = T[keyof T]; // get value of object type

export const Variations = <const>{
  FLAG_CONTROL: 'control',
  FLAG_TARGET: 'target',
  FLAG_TARGET_A: 'target-a',
  FLAG_TARGET_B: 'target-b',
  FLAG_TARGET_C: 'target-c',
  FLAG_EXCLUDED: 'excluded',
}; // readonly properties

export type VariationType = valueof<typeof Variations>; // union type of readonly properties

// Values taken from https://github.com/Jimdo/ui/blob/master/src/components/constants.ts#L38-L43
export enum Breakpoints {
  SM = '576px',
  MD = '768px',
  LG = '992px',
  XL = '1200px',
}

export enum JimdoApp {
  LandingPage = 'lp',
  UserAccount = 'user_account',
  Signup = 'signup',
  LogoTool = 'logo',
  Dash = 'dashboard',
  CMS = 'dolphin_cms',
  CHECKOUT = 'checkout',
  UNDEFINED = 'undefined',
}
